import CategoryBox from "./CategoryBox";
import SiteService from "../../services/SiteService";

export default function CategoriesContainer({renderAllAnyway=false, categories, max}){
	console.log(categories)

	if (!categories) return;
	categories=categories.filter((category) => {
		if (renderAllAnyway) return true;
		if (!category.canonicalApp) return false;
		if (category.canonicalApp !== SiteService.appName) return false;
		return true;
	});

return(
	<div style={{flexDirection:'row', flexFlow:'wrap'}} className={'categoryBoxesContainer'}>
		{categories.map((category,index) => {
			if (max&&index>(max-1))return;
			return <CategoryBox category={category} key={index} />
		})}
	</div>
)}